// Homepage news
$(document).ready(function() {
	let $html = $('html');

	if ($html.attr('id') !== 'homepage-default') {
		return;
	}

	let $controlPlus = $('article a.controlPlus');
	let $controlMinus = $('article a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		$('#newsItems article.large').removeClass('large');
		$(this).parents('article').addClass('large');
		$('#newsItems').addClass('large');

		$('html, body').stop().animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $('article.large').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		$(this).parents('article').removeClass('large');
		$('#newsItems').removeClass('large');

		return false;
	});
});


// News default
$(document).ready(function() {
	let $html = $('html');

	if ($html.attr('id') !== 'news-default') {
		return;
	}

	let $controlPlus = $('article a.controlPlus');
	let $controlMinus = $('article a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		$('article.large').removeClass('large');
		$('sphere-cell').removeClass('large');
		$(this).parents('article').addClass('large');
		$(this).parents('sphere-cell').addClass('large');

		$('html, body').stop().animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $('article.large').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		$(this).parents('article').removeClass('large');
		$('sphere-cell').removeClass('large');

		return false;
	});
});